import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDepartment } from "src/models/HumanResources/Departments.models";

interface DepartmentState {
  departments: IDepartment[];
  departmentToEdit: IDepartment | null;
}

const initialState: DepartmentState = {
  departments: [],
  departmentToEdit: null,
};

const DepartmentSlice = createSlice({
  name: "Department",
  initialState,
  reducers: {
    setDepartmentList: (state, action: PayloadAction<IDepartment[]>) => {
      state.departments = action.payload;
    },
    concatListDepartment: (
      state: DepartmentState,
      action: PayloadAction<IDepartment[]>
    ) => {
      state.departments = [...state.departments.concat(action.payload)];
    },
    setDepartmentToEdit: (state, action: PayloadAction<IDepartment | null>) => {
      state.departmentToEdit = action.payload;
    },
    addDepartment: (state, action: PayloadAction<IDepartment>) => {
      state.departments.push(action.payload);
    },
    updateDepartment: (state, action: PayloadAction<IDepartment>) => {
      let itemIndex = state.departments.findIndex(
        item => item.departmentId === action.payload.departmentId
      );
      if (itemIndex !== -1) state.departments[itemIndex] = action.payload;
    },
    deleteDepartment: (state, action: PayloadAction<number>) => {
      const newArray = state.departments.filter(
        item => item.departmentId !== action.payload
      );
      state.departments = newArray;
    },
  },
});

export const {
  setDepartmentList,
  concatListDepartment,
  setDepartmentToEdit,
  addDepartment,
  updateDepartment,
  deleteDepartment,
} = DepartmentSlice.actions;

export default DepartmentSlice.reducer;
